/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Apps from "@material-ui/icons/Apps";
import Build from "@material-ui/icons/Build";
import Shield from "@material-ui/icons/Security";
import Sports from "@material-ui/icons/SportsHandball";

import Button from "components/CustomButtons/Button.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

import styles from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

import { Auth } from "aws-amplify";
import { RootStoreContext } from "../../mobX/RootStore";
import MultiColumnDropdown from "../MultiColumnDropdown/MultiColumnDropdown";
import { observer } from "mobx-react";
import { getClubURI } from "../../utils/Utils";

async function signOut() {
	try {
		await Auth.signOut();
	} catch (error) {
		console.error("error signing out: ", error);
	}
}

const SportappHeaderLinks = observer((props) => {
	const store = useContext(RootStoreContext);
	const [isTenant, setIsTenant] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const getCategories = () => {
		const offeringCategories = store.offeringStore.validCategories.map(
			(category) => ({
				category,
			}),
		);
		const courseCategories = store.courseStore.validCategories.map(
			(category) => ({
				category,
			}),
		);
		const allCategories = [...offeringCategories, ...courseCategories]
			.filter(
				(value, index, array) =>
					array.findIndex((element) => element.category === value.category) ===
					index,
			)
			.sort((a, b) => a.category.localeCompare(b.category));
		return [{ category: "Alle", highlighted: true }, ...allCategories];
	};

	const clubs = [
		{ name: "Alle", id: "", highlighted: true },
		...store.clubStore.filteredClubs,
	];
	const categories = getCategories();

	const events = store.eventStore.events;
	const highlightedEvents = events.filter((event) => event.highlighted);

	useEffect(() => {
		store.clubStore.fetchClubNames();
		store.offeringStore.fetchCategories();
		store.courseStore.fetchCategories();
		store.eventStore.fetchEventNames();
	}, []);

	useEffect(() => {
		Auth.currentAuthenticatedUser({
			bypassCache: false,
		})
			.then((user) => {
				setIsLoggedIn(true);
				if (
					user.signInUserSession.accessToken.payload["cognito:groups"]?.find(
						(group) => group === "SG-Admins",
					)
				) {
					setIsTenant(true);
				}
			})
			.catch(() => {
				setIsLoggedIn(false);
			});
	}, []);

	const getEventNameForURL = (eventName) =>
		eventName.toLowerCase().replaceAll(" ", "-");

	const { dropdownHoverColor } = props;
	const classes = useStyles();

	return (
		<div className={classes.collapse}>
			<List className={classes.list + " " + classes.mlAuto}>
				{highlightedEvents.map((event) => (
					<ListItem key={event.id} className={classes.listItem}>
						<Button
							href={`/events/${getEventNameForURL(event.name)}`}
							color={window.innerWidth < 960 ? "info" : "info"}
							className={classes.navButton}
							round
						>
							{event.icon && <i className={`${event.icon} ${classes.icons}`} />}
							{event.name}
						</Button>
					</ListItem>
				))}

				<ListItem className={classes.listItem}>
					<MultiColumnDropdown
						buttonText="Aktivitäten"
						buttonIcon={Sports}
						buttonProps={{
							className: classes.navLink,
							color: "transparent",
						}}
						ratio={3 / 10}
						keyExtractor={(item) => item.category}
						itemToDisplay={(item) => item.category}
						onClick={(item) => {
							if (item.category === "Alle") {
								window.location.assign("/activities");
							} else {
								window.location.assign(
									`/activities/filter&searchText=${encodeURIComponent(
										item.category,
									)}`,
								);
							}
						}}
						data={categories}
						navDropdown
					/>
				</ListItem>

				<ListItem className={classes.listItem}>
					<MultiColumnDropdown
						buttonText="Vereine"
						buttonIcon={Shield}
						buttonProps={{
							className: classes.navLink,
							color: "transparent",
						}}
						ratio={3 / 10}
						keyExtractor={(item) => item.id}
						itemToDisplay={(item) => item.name}
						onClick={(club) => {
							if (club.name === "Alle") {
								window.location.assign("/clubs");
							} else {
								window.location.assign(getClubURI(club.name, club.id));
							}
						}}
						data={clubs}
						navDropdown
					/>
				</ListItem>

				<ListItem className={classes.listItem}>
					<Button
						href="/events/"
						className={classes.navLink}
						color="transparent"
					>
						Veranstaltungen
					</Button>
				</ListItem>

				{isLoggedIn && (
					<ListItem className={classes.listItem}>
						<CustomDropdown
							noLiPadding
							navDropdown
							hoverColor={dropdownHoverColor}
							buttonText="Administration"
							buttonProps={{
								className: classes.navLink,
								color: "transparent",
							}}
							buttonIcon={Build}
							dropdownList={
								isTenant
									? [
											<Link
												to="/admin/dashboard"
												className={classes.dropdownLink}
											>
												<Apps className={classes.dropdownIcons} /> Dashboard
											</Link>,
									  ]
									: [
											<Link
												to="/admin/dashboard"
												className={classes.dropdownLink}
											>
												<Apps className={classes.dropdownIcons} /> Mein Verein
											</Link>,
									  ]
							}
						/>
					</ListItem>
				)}

				<ListItem className={classes.listItem}>
					{isLoggedIn ? (
						<Button
							href="/"
							onClick={() => {
								signOut();
							}}
							color={window.innerWidth < 960 ? "danger" : "danger"}
							className={classes.navButton}
							round
						>
							<i className={`fas fa-sign-out-alt ${classes.icons}`} /> Abmelden
						</Button>
					) : (
						<Button
							href="/admin/dashboard"
							color={window.innerWidth < 960 ? "info" : "white"}
							className={classes.navButton}
							round
						>
							<i className={`fas fa-sign-in-alt ${classes.icons}`} /> Mein
							Verein
						</Button>
					)}
				</ListItem>
			</List>
		</div>
	);
});

SportappHeaderLinks.defaultProps = {
	hoverColor: "primary",
};

SportappHeaderLinks.propTypes = {
	dropdownHoverColor: PropTypes.oneOf([
		"dark",
		"primary",
		"info",
		"success",
		"warning",
		"danger",
		"rose",
	]),
};

export default SportappHeaderLinks;
